const ngModule = angular.module('ppa.values.base-api', []);

ngModule.constant("baseApi", BASE_API);